import React, { useEffect, useMemo, useState } from 'react';
import useReRouteHook from '../../assets/hooks/useReRouteHook';
import { getTopFaqs } from '../../services/api/Api';
import { IFaq } from '../../types/types';
import SkeletonComponent from '../SkeletonComponent';

const MostSearchFaq = () => {
	const [topFaqs, setTopFaqs] = useState<IFaq[]>([]);
	const [topFaqLoading, setTopFaqLoading] = useState(false);
	const { reRouteButtonRenderer } = useReRouteHook();

	useEffect(() => {
		const fetchTopFaqsData = async () => {
			try {
				setTopFaqLoading(true);
				const response = await getTopFaqs();
				if (response.message === 'Success') {
					setTopFaqs(response?.data);
				}
			} catch (error) {
				console.error('Failed to fetch FAQ data:', error);
			} finally {
				setTopFaqLoading(false);
			}
		};

		fetchTopFaqsData();
	}, []);

	const sortedTopFaqs = useMemo(
		() =>
			[...topFaqs]
				.sort((a: IFaq, b: IFaq) => {
					const dateA = new Date(a.top_ranked_date);
					const dateB = new Date(b.top_ranked_date);

					return dateB.getTime() - dateA.getTime();
				})
				.slice(0, 5),
		[topFaqs],
	);

	if (!topFaqLoading && topFaqs.length === 0) {
		return null;
	}

	return (
		<div>
			{(topFaqLoading || topFaqs.length > 0) && (
				<div className="top-faq-headline text-start ur_ebold color28 mb-4">
					Most Searched FAQs
				</div>
			)}
			<div className="row gap-3">
				{topFaqLoading ? (
					<SkeletonComponent name="TopFaq" />
				) : (
					sortedTopFaqs.map((faq: IFaq, index: number) => {
						const cmsCategory = faq.cms_category_id;
						const parentCategory = faq.parent_map_id[0];
						const MainCategory = faq.parent_map_id[1];

						return (
							<div key={faq.id || index} className="col-12">
								<ul className="mb-0 list-unstyled">
									<li className="text-start">
										<div>
											{reRouteButtonRenderer({
												url: `/category/${encodeURIComponent(
													MainCategory,
												)}/${encodeURIComponent(parentCategory)}/${encodeURIComponent(
													cmsCategory,
												)}/${encodeURIComponent(faq.id)}`,
												classes:
													'color1 top-faq-title text-decoration-none in_med lh-21 p-0',
												nameText: faq.title || 'FAQ Question',
											})}
										</div>
										{/* {reRouteButtonRenderer({
											url: `/category/${encodeURIComponent(
												MainCategory,
											)}/${encodeURIComponent(parentCategory)}/${encodeURIComponent(
												cmsCategory,
											)}`,
											classes:
												'color38 top-faq-category text-decoration-none in_reg my-1',
											nameText: faq.cms_category || 'FAQ Category',
										})} */}
									</li>
								</ul>
							</div>
						);
					})
				)}
			</div>
		</div>
	);
};

export default MostSearchFaq;
